import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader, CardTitle, CardSubtitle, Button } from 'reactstrap'
import { InputGroup, Form } from 'react-bootstrap'

import SurveyResponsesTable from './partials/SurveyResponsesTable'
import { getSurveyResponses } from './services'
import { handleError, parsePagination } from '../../helpers'

export default function SurveyResponsesList() {
	const [surveyResponses, setSurveyResponses] = useState(null)
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const [filterType, setFilterType] = useState('survey.name')
	const [filterValue, setFilterValue] = useState('')

	useEffect(()=>{
		!surveyResponses && getSurveyResponses({
			...pagination,
			[`filter[${filterType}]`]: filterValue,
			include: 'survey,user,answers'
		})
			.then(res => {
				setSurveyResponses(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [surveyResponses, pagination, filterType, filterValue])

	return (
		<React.Fragment>
			<Card>
				<CardHeader>
					<div className="float-right mt-2">
						<InputGroup>
							<InputGroup.Prepend>
								<Form.Control 
									as="select" 
									className="bg-light"
									value={filterType}
									onChange={e => setFilterType(e.target.value)}
								>
									<option value="survey.name">Buscar por nombre de encuesta</option>
									<option value="user.name">Buscar por nombre de usuario</option>
								</Form.Control>
							</InputGroup.Prepend>
							<Form.Control 
								placeholder="Escriba aquí" 
								value={filterValue}
								onChange={e => setFilterValue(e.target.value)}
							/>
							<InputGroup.Append>
								<Button color="primary" onClick={()=>setSurveyResponses(null)}>Buscar</Button>
							</InputGroup.Append>
						</InputGroup>
					</div>
					<CardTitle>Listado de Encuestas Digilenciadas</CardTitle>
					<CardSubtitle>Listados de encuestas registrados desde el aplicativo</CardSubtitle>
				</CardHeader>
				<CardBody>
					<SurveyResponsesTable 
						surveyResponses={surveyResponses} 
						reload={()=>setSurveyResponses(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
		</React.Fragment>
	)
}